import { useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

interface IParams {
  start_date: string;
  end_date: string;
  branches?: number[];
  enabled?: boolean;
}

export const useGetTrialBalanceReportData = (params: IParams) =>
  useQuery<any, APIErrorResponse, { data: any }>({
    queryKey: [
      "get-new-trial-balance-report-data",
      params.start_date,
      params.end_date,
      (params.branches ?? []).join(","),
      params.enabled ?? true,
    ],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.set("start_date", params.start_date);
      searchParams.set("end_date", params.end_date);
      (params.branches ?? []).forEach((id) =>
        searchParams.append("branches[]", String(id)),
      );
      return apiClient.get(
        `/api/reports/trial-balance?${searchParams.toString()}`,
      );
    },
    enabled: params.enabled !== false,
    gcTime: 0,
  });

interface ISheetParams {
  date: string;
  period: string;
  branches?: number[];
  enabled?: boolean;
}
export const useGetBalanceSheetReportData = (params: ISheetParams) =>
  useQuery<any, APIErrorResponse, { data: any }>({
    queryKey: [
      "get-new-balance-sheet-report-data",
      params.date,
      params.period,
      (params.branches ?? []).join(","),
      params.enabled ?? true,
    ],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.set("date", params.date);
      searchParams.set("period", params.period);
      (params.branches ?? []).forEach((id) =>
        searchParams.append("branches[]", String(id)),
      );
      return apiClient.get(
        `/api/reports/balance-sheet?${searchParams.toString()}`,
      );
    },
    enabled: params.enabled !== false,
    gcTime: 0,
  });
